"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEventResultsApi = fetchEventResultsApi;
exports.fetchLinkedEventsSaga = fetchLinkedEventsSaga;
exports.fetchLinkedEvents = fetchLinkedEvents;
exports.fetchResultsSaga = fetchResultsSaga;
exports.fetchEventResultsSaga = fetchEventResultsSaga;
exports.fetchResultCountersSaga = fetchResultCountersSaga;
exports.fetchResultsBySportsSaga = fetchResultsBySportsSaga;
exports.resultsProviderSaga = resultsProviderSaga;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const effects_1 = require("redux-saga/effects");
const dayjs_1 = __importDefault(require("dayjs"));
const selectors_1 = require("../LanguagesProvider/selectors");
const linkedEvents_1 = require("../../utils/events/linkedEvents");
const saga_1 = require("../ConfigProvider/saga");
const results_1 = require("../../utils/results");
const CommonDataProvider_1 = require("../CommonDataProvider");
const index_1 = require("../../api/index");
const slice_1 = require("../SportCountersProvider/slice");
const saga_2 = require("../SportCountersProvider/saga");
const constants_1 = require("../SportCountersProvider/constants");
const types_1 = require("../SportCountersProvider/types");
const errors_1 = require("../../utils/errors");
const ConfigProvider_1 = require("../ConfigProvider");
const constants_2 = require("./constants");
const slice_2 = require("./slice");
const selectors_2 = require("./selectors");
const utils_1 = require("./utils");
function* fetchEventResultsApi(reqPayload, skipPageSize = false) {
    const eventResultsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.EventResultsApi);
    const isNewResultsEndpoint = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.NEW_RESULTS_ENDPOINT);
    const finalPayload = isNewResultsEndpoint && !skipPageSize
        ? {
            ...reqPayload,
            pageSize: reqPayload.pageSize || constants_2.MIN_PAGE_SIZE,
        }
        : reqPayload;
    const apiMethod = isNewResultsEndpoint
        ? eventResultsApi.getEventResultsV2
        : eventResultsApi.getEventResults;
    const { data: resData, headers } = yield (0, effects_1.call)([eventResultsApi, apiMethod], finalPayload);
    return { resData, headers };
}
function* fetchLinkedEventsSaga(action) {
    yield (0, effects_1.call)(fetchLinkedEvents, action.payload.events);
}
function* fetchLinkedEvents(events) {
    try {
        const ids = (0, linkedEvents_1.getLinkedEventsIds)(events);
        if (ids.length === 0) {
            return;
        }
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const requestPayload = {
            ids,
            locale,
            pageSize: constants_2.MIN_PAGE_SIZE,
        };
        const { resData: { items }, } = yield (0, effects_1.call)(fetchEventResultsApi, requestPayload);
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchLinkedEventsSuccess({ items }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Couldnt fetch linked events for results', error);
    }
}
function* fetchResultsSaga(action) {
    try {
        const { withLinkedEvents, paginationFetch, withoutCounters, reqData } = action.payload;
        const sportId = yield (0, effects_1.select)(selectors_2.selectResultsFilterSportId);
        const date = yield (0, effects_1.select)(selectors_2.selectResultsFilterDate);
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const isNewCountersEndpoint = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.NEW_COUNTERS_ENDPOINT);
        // TODO:PLAT-867 Remove after release
        const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
        const requestPayload = yield (0, effects_1.call)(utils_1.createResultsReq, {
            ...reqData,
            date,
            locale,
            sportId,
        }, isGenericSportsEnabled);
        const { resData } = yield (0, effects_1.call)(fetchEventResultsApi, requestPayload);
        const { items, paginationKey = null } = resData;
        if (isNewCountersEndpoint) {
            if (!paginationFetch && !withoutCounters) {
                yield (0, effects_1.call)(saga_2.fetchEventResultCountersSaga, slice_1.sportCountersProviderActions.fetchEventResultCounters({
                    key: types_1.ESportsCounterType.RESULTS,
                    reqData: constants_1.DefaultCountersReq.RESULTS,
                    aggregateByGeneric: isGenericSportsEnabled || undefined,
                }));
            }
        }
        else {
            yield (0, effects_1.call)(fetchResultCountersSaga, slice_2.resultsProviderActions.fetchResultCounters({
                aggregateByGeneric: isGenericSportsEnabled || undefined,
            }));
        }
        // process here
        let groupedResults;
        if (isGenericSportsEnabled) {
            groupedResults = (0, results_1.groupResultsBySportAndTournament)(items, sportId);
        }
        else {
            groupedResults = (0, results_1.groupResultsBySportAndTournament)(items);
        }
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchResultsSuccess({
            groupedResults,
            paginationKey,
            paginationFetch,
        }));
        const isLinkedEventsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.LINKED_EVENTS_ENABLED);
        if (isLinkedEventsEnabled && withLinkedEvents === true) {
            yield (0, effects_1.fork)(fetchLinkedEvents, items);
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error("Couldn't fetch eventResults", error);
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchResultsError(error));
    }
}
function* fetchEventResultsSaga(action) {
    try {
        const { eventId } = action.payload;
        const currentLangCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const requestPayload = {
            ids: [eventId],
            locale: currentLangCode,
        };
        const { resData } = yield (0, effects_1.call)(fetchEventResultsApi, requestPayload, true);
        const { items } = resData;
        if (items.length === 0) {
            throw new Error('Event not found');
        }
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchEventResultsSuccess());
        yield (0, effects_1.put)(slice_2.resultsProviderActions.updateEventResults({ eventResults: items }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error("Couldn't fetch eventResult", error);
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchEventResultsError(error));
    }
}
function* fetchResultCountersSaga(action) {
    var _a;
    try {
        const api = index_1.ApiManager.getApi(betweb_openapi_axios_1.SportsCountersApi);
        const date = yield (0, effects_1.select)(selectors_2.selectResultsFilterDate);
        // TODO:OL-867 Remove after release
        const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
        const requestPayload = {
            date: (0, dayjs_1.default)(date).format(constants_2.DATE_FORMAT),
            aggregateByGeneric: (_a = action.payload.aggregateByGeneric) !== null && _a !== void 0 ? _a : (isGenericSportsEnabled || undefined),
        };
        const { data: { items }, } = yield (0, effects_1.call)([api, api.getResultSportsCounters], requestPayload);
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchResultCountersSuccess({ items }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchResultCountersError(error));
    }
}
function* fetchResultsBySportsSaga(action) {
    try {
        let { sportIds } = action.payload;
        const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
        if (isGenericSportsEnabled) {
            const childrenMap = yield (0, effects_1.select)(CommonDataProvider_1.selectChildrenSportMap);
            sportIds = sportIds.flatMap((sportId) => childrenMap[sportId] ? childrenMap[sportId] : [sportId]);
        }
        const date = yield (0, effects_1.select)(selectors_2.selectResultsFilterDate);
        const currentLangCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const datePayload = (0, utils_1.createDatePayload)(date);
        const requestPayload = {
            ...datePayload,
            sportIds,
            locale: currentLangCode,
        };
        const { resData: { items }, } = yield (0, effects_1.call)(fetchEventResultsApi, requestPayload);
        const groupedResults = (0, results_1.groupResultsBySportAndTournament)(items);
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchResultsSuccess({ groupedResults }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error("Couldn't fetch eventResultsBySport", error);
        yield (0, effects_1.put)(slice_2.resultsProviderActions.fetchResultsError(error));
    }
}
function* resultsProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_2.resultsProviderActions.fetchResults, fetchResultsSaga),
        (0, effects_1.takeLatest)(slice_2.resultsProviderActions.fetchResultsBySports, fetchResultsBySportsSaga),
        (0, effects_1.takeLatest)(slice_2.resultsProviderActions.fetchEventResults, fetchEventResultsSaga),
        (0, effects_1.takeLatest)(slice_2.resultsProviderActions.fetchResultCounters, fetchResultCountersSaga),
        (0, effects_1.takeLatest)(slice_2.resultsProviderActions.setDateFilter, fetchResultsSaga),
        (0, effects_1.takeLatest)(slice_2.resultsProviderActions.setCurrentSportIdFilter, fetchResultsSaga),
        (0, effects_1.takeLatest)(slice_2.resultsProviderActions.fetchLinkedEvents, fetchLinkedEventsSaga),
    ]);
}
//# sourceMappingURL=saga.js.map